import React from 'react'
import { Layout } from './Layout'
import { Provider } from './Context'

export const CardPanel = () => {
  return (
    <Provider>
      <Layout />
    </Provider>
  )
}
